export var Brand;
(function (Brand) {
    Brand["BMW"] = "BMW";
    Brand["MINI"] = "MINI";
    Brand["MOT"] = "MOT";
    Brand["BMW_i"] = "BMW i";
    Brand["RR"] = "RR";
    Brand["C_1"] = "C_1";
    Brand["ZINORO"] = "ZINORO";
    Brand["TOYOTA"] = "TOYOTA";
    Brand["HUSQVARNA"] = "HUSQVARNA";
    Brand["UNKNOWN"] = "UNKNOWN";
})(Brand || (Brand = {}));
//# sourceMappingURL=brand.js.map